import styled from 'styled-components';

export const StyledHighlightIcon = styled.div`
  padding-right: 1.5rem;
  font-size: 24px;
  text-align: center;
  width: 1.5rem;
  margin-left: -4px;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: #3e7697;
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledText = styled.div`
  padding-bottom: 5px;
`;

export const StyledHighlights = styled.section`
  min-height: 3.5rem;
  margin-top: 1rem;
  & > ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    line-height: 1;
    align-items: center;
    & > li {
      display: flex;
      width: 100%;
      position: relative;
      align-items: center;
      margin-bottom: 1rem;
    }
  }
`;
